export enum Code {
  Success = 200,
  NoContent = 204,
  ClientError = 400,
  NotFound = 404,
  ServeurError = 500,
  NotImplemented = 501,
  InvalidRequest = 600
}
